import { VoiceRecognition, VoiceRecognitionCallbacks } from './voice-recognition';
import { SpeechUI } from './speech-ui';

export class SpeechManager {
  private static instance: SpeechManager | null = null;
  private isInitialized: boolean = false;
  private gameInstance: any = null;
  private voiceRecognition: VoiceRecognition | null = null;
  private speechUI: SpeechUI | null = null;

  private constructor() {}

  static getInstance(): SpeechManager {
    if (!SpeechManager.instance) {
      SpeechManager.instance = new SpeechManager();
    }
    return SpeechManager.instance;
  }

  init(game: any): void {
    if (this.isInitialized) {
      return;
    }

    this.gameInstance = game;

    // Create UI
    this.speechUI = new SpeechUI();

    // Create callbacks for UI updates
    const callbacks: VoiceRecognitionCallbacks = {
      onStart: () => {
        if (this.speechUI) {
          this.speechUI.setListening(true);
        }
      },
      onEnd: () => {
        if (this.speechUI) {
          this.speechUI.setListening(false);
        }
      },
      onResult: (transcript: string, isFinal: boolean) => {
        if (this.speechUI) {
          this.speechUI.showRecognized(transcript, isFinal);
        }
      },
      onCommandMatch: (command: string) => {
        if (this.speechUI) {
          this.speechUI.showCommandMatched(command);
        }
      },
      onError: (error: string) => {
        if (this.speechUI) {
          this.speechUI.showError(error);
        }
      },
      onSpeechDetection: (isDetecting: boolean) => {
        if (this.speechUI) {
          this.speechUI.setSpeechDetecting(isDetecting);
        }
      },
    };

    // Create voice recognition with callbacks
    this.voiceRecognition = new VoiceRecognition(callbacks);

    if (!this.voiceRecognition.isSupported()) {
      console.warn('Speech recognition not supported in this browser');
      if (this.speechUI) {
        this.speechUI.showError('Speech recognition not supported in this browser');
      }
      return;
    }

    // Add voice commands
    this.voiceRecognition.addCommand('start', () => {
      console.log('Voice command: start');
      this.startGame();
    });

    this.voiceRecognition.addCommand('start game', () => {
      console.log('Voice command: start game');
      this.startGame();
    });

    this.voiceRecognition.addCommand('menu', () => {
      console.log('Voice command: menu');
      this.openMainMenu();
    });

    this.voiceRecognition.addCommand('main menu', () => {
      console.log('Voice command: main menu');
      this.openMainMenu();
    });

    // Start listening
    this.voiceRecognition.start();

    this.isInitialized = true;
    console.log('Speech recognition initialized');
  }

  private startGame(): void {
    if (!this.gameInstance) return;

    const currentScene = this.gameInstance.scene.getScenes(true)[0];
    if (currentScene && currentScene.scene.key === 'MainMenuScene') {
      this.gameInstance.scene.start('PokemonDemoScene');
    }
  }

  private openMainMenu(): void {
    if (!this.gameInstance) return;

    const currentScene = this.gameInstance.scene.getScenes(true)[0];
    if (currentScene) {
      this.gameInstance.scene.start('MainMenuScene');
    }
  }

  addCommand(command: string, callback: () => void): void {
    if (this.voiceRecognition) {
      this.voiceRecognition.addCommand(command, callback);
    }
  }

  removeCommand(command: string): void {
    if (this.voiceRecognition) {
      this.voiceRecognition.removeCommand(command);
    }
  }

  stop(): void {
    if (this.voiceRecognition && this.isInitialized) {
      this.voiceRecognition.stop();
    }
  }

  start(): void {
    if (this.voiceRecognition && this.isInitialized) {
      this.voiceRecognition.start();
    }
  }
}

export default SpeechManager.getInstance();
